import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CredentialsService } from "src/app/core/credentials.service";
import { TranslateService } from "@ngx-translate/core";
import { SortOrder } from "src/app/shared/pipes/order-by/order-by.model";
import { SocketEvents } from "../socketio.service";
import { ConnectionService } from "../connection.service";
export interface Section {
  Name: string;
  Complaint: string;
}

export interface TimeSpan {
  hours: number;
  minutes: number;
  seconds: number;
}

@Component({
  selector: "app-main-page",
  templateUrl: "./main-page.component.html",
  styleUrls: ["./main-page.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent implements OnInit {
  doctorRole: any;
  widthSet = false;
  messages: any[] = [];
  messagesSpecialty: any[] = [];
  inProcessConsult: any = [];
  recentConsult: any = [];
  averagetimeConsult: any = [];
  waitingtimeConsult: any = [];
  waitingTime: any = [];
  public singPatientRecord: any;
  followUpList: any[] = [];
  consultComplete: boolean = false;
  currentLanguage: string = "es";
  fileUrl: string;
  loading: boolean = true;
  sortOrder = SortOrder;

  constructor(
    private translateService: TranslateService,
    private credentialService: CredentialsService,
    private connectionService: ConnectionService,
  ) {}

  ngOnInit(): void {
    this.connectionService.connect();
    this.doctorRole = this.credentialService.credentials.userDetails.doctorRole;
    
    if (this.translateService.currentLang == "en-US") {
      this.currentLanguage = "en";
    }
    localStorage.removeItem("patientDetails");
    this.sendMessage();
  }

  sendMessage() {
    if ( this.doctorRole == 1 ) {
      this.connectionService.sendMsg(SocketEvents.WaitingRoom);
      this.connectionService.sendMsg(SocketEvents.FollowUpRoom);
    } 
    else {
      this.connectionService.sendMsg(SocketEvents.DoctorSpecialistWaitingRoom);
    }
  }
}
